export const resolveUnauthorizedFromUrl = (): boolean => {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.get("login_error") === "unauthorized";
};
